import React, { Component } from "react";
import { } from "../../services/gendropdown";
// import { RealTimeFind } from "../../services/realtimeservice";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { closemodal } from "../../actions/modal-handler";
import { Modal, Header, Button, Table, Checkbox, Tab, Input, Form } from "semantic-ui-react";
import moment from "moment";
class MatFilterModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selected_wods: [],
      payment_options: [],
      selected: [],
      selected_vendors: [],
      results: [],
      defaultStartDate: null,
      defaultEndDate: null,
      startDate: null,
      endDate: null
    };
  }

  componentDidUpdate(prevProps, prevState) {
    console.log("tnm", this.state.tnm, "invoice", this.state.invoice);
    if (this.props.vendors) {
    }
  }
  componentDidMount() {
    if (this.props.matcharges && this.props.matcharges[0]) {
      this.props.handleResults(this.props.matcharges);
      var startDate = this.props.matcharges[0].datepurchased;
      var endDate = this.props.matcharges[0].datepurchased;
      this.props.matcharges.forEach(mc => {
        if (startDate > mc.datepurchased) {
          startDate = mc.datepurchased
        }
        if (endDate < mc.datepurchased) {
          console.log("Date Purchased.", mc.datepurchased)
          endDate = mc.datepurchased
        }
      });
      this.setState({
        startDate,
        defaultStartDate: startDate,
        endDate,
        defaultEndDate: endDate
      })
    }
  }
  addResults(key, value) {
    let results = Array.from(this.state.results);
    this.props.matcharges.filter((mc) => mc[key] === value).map((mc) => {
      if (results.findIndex((r) => r.id === mc.id) === -1) {
        results = results.concat(mc);
      }
    });
    console.log(`Added ${results.length - this.state.results.length} entries`)

    this.setState({ results });
  }
  filterResultsDate() {
    let results = Array.from(this.state.results);
    results = results.filter(r =>
      r.datepurchased >= this.state.startDate
      && r.datepurchased <= this.state.endDate
    );
    // console.log("Filtered "+ (this.state.results.length - results.length) + " results");
    // console.log("Start Date: ", this.state.startDate);
    return results;
  }
  removeResults(key, value) {
    let results = Array.from(this.state.results);
    this.props.matcharges.filter((mc) => mc[key] === value).map((mc) => {
      let resIndex = results.findIndex((r) => r.id === mc.id);
      if (resIndex > -1) {
        results.splice(resIndex, 1);
      }
    });
    console.log(`Removed ${this.state.results.length - results.length} entries`)
    this.setState({ results });
  }

  genSelectRow(va) {
    return va.map((vendor) => {
      // console.log("vendor", vendor);
      let checked = this.state.results.find(r => r.matname === vendor.companyname);
      return (
        <Table.Cell>
          <Checkbox
            label={vendor.companyname}
            checked={checked}
            onChange={() => {
              if (checked) {
                this.removeResults("matname", vendor.companyname);
              } else {
                this.addResults("matname", vendor.companyname);
              }
            }}
          />
        </Table.Cell>
      );
    });
  }
  genSelectTable() {
    var array = this.props.vendors.filter(
      (vendor) =>
        this.props.matcharges.findIndex(
          (mc) => mc.matnumber === vendor.matnumber
        ) > -1
    );
    var vendor_array = this.chunkGen(array, 5);
    return vendor_array.map((va) => {
      return <Table.Row>{this.genSelectRow(va)}</Table.Row>;
    });
  }
  chunkGen(data, chunk = 5) {
    var i;
    var j;
    var array = [];
    for (i = 0, j = data.length; i < j; i += chunk) {
      array = array.concat([data.slice(i, i + chunk)]);
    }
    return array;
  }

  genSelectWodTable() {
    let wodlist = [
      ...new Set(this.props.matcharges.map((item) => item.workordernumber)),
    ];
    wodlist = this.chunkGen(wodlist);
    console.log("WodList", wodlist);
    return wodlist.map((wl) => {
      return (
        <Table.Row>
          {wl.map((wonum) => {
            let checked = this.state.results.find(r => r.workordernumber === wonum)
            return (
              <Table.Cell>
                <Checkbox
                  label={wonum}
                  checked={checked}
                  onChange={() => {
                    if (checked) {
                      this.removeResults("workordernumber", wonum)
                    } else {
                      this.addResults("workordernumber", wonum)
                    }
                  }}
                />
              </Table.Cell>
            );
          })}
        </Table.Row>
      );
    });
  }
  VendorOptions() {
    return (
      <Modal.Content>
        <Table>
          <Table.Body>{this.genSelectTable()}</Table.Body>
        </Table>
      </Modal.Content>
    );
  }
  WodOptions() {
    return (
      <Modal.Content>
        <Table>
          <Table.Body>{this.genSelectWodTable()}</Table.Body>
        </Table>
      </Modal.Content>
    );
  }
  PaymentOptions() {
    let Payments = [
      ...new Set(this.props.matcharges.map((item) => item.payment_type)),
    ];
    return (
      <Modal.Content>
        {Payments.map((p) => {
          if (p) {
            let checked = this.state.results.find(r => r.payment_type === p)
            return (
              <Checkbox
                label={p}
                checked={checked}
                onChange={() => {
                  if (checked) {
                    this.removeResults('payment_type', p)
                  } else {
                    this.addResults('payment_type', p)
                  }
                }}
              />
            );
          }
        })}
      </Modal.Content>
    );
  }
  DateRangeOptions() {
    return (
      <Modal.Content>
        <Form>
          <Input type="date" label="Start Date" value={this.state.startDate} onChange={e => {
            this.setState({ startDate: e.target.value })
          }} />
          <br/>
          <Input type="date" label="End Date" value={this.state.endDate} onChange={e => {
            this.setState({ endDate: e.target.value })
          }}
          />
          <br/>
          <Button
              inverted
              color="green"
              onClick={() => {
                this.setState({
                  endDate: this.state.defaultEndDate,
                  startDate: this.state.defaultStartDate
                })
              }}
            >
              Clear
            </Button>


        </Form>
      </Modal.Content>
    );
  }
  render() {
    let header = "Select Filtering options: ";
    let matEntry = this.state.matentry;
    const panes = [
      {
        menuItem: "Vendor",
        render: () => <Tab.Pane>{this.VendorOptions()}</Tab.Pane>,
      },
      {
        menuItem: "Work Order",
        render: () => <Tab.Pane>{this.WodOptions()}</Tab.Pane>,
      },
      {
        menuItem: "Payment",
        render: () => <Tab.Pane>{this.PaymentOptions()}</Tab.Pane>,
      },
      {
        menuItem: "Date Range",
        render: () => <Tab.Pane>{this.DateRangeOptions()}</Tab.Pane>,
      },
    ];
    return (
      <div className="MatFilterModal">
        <Modal
          open={this.props.showModal}
          onClose={() => {
            this.props.closemodal();
          }}
          closeOnEscape
          closeOnRootNodeClick
          size="large"
        >
          <Header as="h2">{header}</Header>
          <Tab panes={panes} />
          <Modal.Actions>
            <Button
              inverted
              color="blue"
              disabled={this.state.activeIndex}
              onClick={() => {
                this.props.closemodal();
                this.props.handleResults(this.filterResultsDate(this.state.results));
              }}
            >
              OK
            </Button>
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    showModal: state.modal === "matfilter",
  };
}
function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      closemodal: closemodal,
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  matchDispatchToProps
)(MatFilterModal);



// WEBPACK FOOTER //
// ./src/components/reports/matfiltermodal.js